import React from 'react'
import { CustomEvents } from '../ApplicationConfig/constants';

export default function PageLoadEventEmitter(props)
{
    var event = new Event(CustomEvents.PageLoaded);
    document.getElementById('customEventsEmitter').dispatchEvent(event)
    return (props.children)
}